import React, { createContext, useContext, useReducer } from 'react';


const eventState = {  
  groupsLocationsStatus: "idle",

  modulesStatus: "idle",
  scenariosStatus: "idle",
  deploymentsStatus: "idle",

  reportingColumnsStatus: "idle",
  reportsStatus: "idle",

  refreshSelectedLocations: "off",
  autoApply: "on",
  canApply: "off" // on
  
  //autoApply: "off",
  //canApply: "on"
  
  // refreshGroups: false,
  // groupsPending: false,
  // groupsLoaded: false,

  // refreshLocations: false,
  // locationsPending: false,
  // locationsLoaded: false,

  // refreshScenarios: false,
  // scenariosLoaded: false,
  // scenariosLoading: false,
  // scenariosPending: false,

  // refreshDeployments: false,
  // deploymentsLoaded: false,
  // deploymentsPending: false,

  // refreshReportingColumns: false,
  // reportingColumnsLoaded: false,

  // refreshReports: false
};

const EventContext = createContext();
export const EventProvider = ({ reducer, children }) => (
  <EventContext.Provider value={useReducer(reducer, eventState)}>
    {children}
  </EventContext.Provider>
);

export const useEventContext = () => useContext(EventContext);
